import { zodResolver } from '@hookform/resolvers/zod';
import { Modal } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { CenterReportCriteriaInfraRequest } from '@/module/ResearchCenter';

import { Form, TextInputControl } from '@/core/components';

interface InfraAddFormProps {
  onClose: () => void;
  isSubmitting: boolean;

  onChange: (request: CenterReportCriteriaInfraRequest) => void;
}

export const infraAddSchema = z.object({
  infrastructure: z.string().toLowerCase().trim().min(3),
});

type InfraAddSchema = z.infer<typeof infraAddSchema>;

export function InfraAddForm(props: InfraAddFormProps) {
  const { onClose, isSubmitting, onChange } = props;
  const { t } = useTranslation();
  const form = useForm<InfraAddSchema>({
    defaultValues: { infrastructure: '' },
    resolver: zodResolver(infraAddSchema),
  });

  return (
    <Modal
      opened
      onClose={onClose}
      size="lg"
      title={t('labs.infraTitle')}
    >
      <FormProvider {...form}>
        <Form
          onSubmit={form.handleSubmit(onChange)}
          onCancel={onClose}
          title=""
          isSubmitting={isSubmitting}
        >
          <TextInputControl<InfraAddSchema>
            label={t('labs.infrastructure')}
            name="infrastructure"
            description={t('labs.infrastructure')}
            isSubmitting={isSubmitting}
          />
        </Form>
      </FormProvider>
    </Modal>
  );
}
